module.exports = __webpack_public_path__ + "img/Yipi_AnimacionWeb_09_Ipad.bf6906c6.gif";